<template>
    <div class="treeBox">
        <Tree ref="tree" :data="treeDataList" expand-node show-checkbox @on-check-change="getChecked"></Tree>
    </div>
</template>

<script>
export default {
    props:['treeData'],
    data(){
        return{
            expandAll: false,
            treeDataList:[],
            data:[]
        }
    },
    methods:{
        toggleExpand(data,val) {
            return data.map(obj=>{
                if(obj.children && obj.children.length > 0){
                    this.$set(obj, "expand", val);
                    obj.title = obj.c_name
                    obj.beUsed=="1"?this.$set(obj, "checked", true):this.$set(obj, "checked", false)
                    obj.children = this.toggleExpand(obj.children,val)
                    return obj
                } else {
                  //  this.$set(obj, "expand", val);
                    obj.title = obj.c_name
                    obj.beUsed=="1"?this.$set(obj, "checked", true):this.$set(obj, "checked", false)
                    return obj
                }
            })
        },
        getChecked(array){
            this.$emit('getTreeChecked',array)
        }
    }
}
</script>

<style scoped>
.treeBox {
    height: calc(100vh - 300px);
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/components/TreeComponent.vue